import React from 'react';
import { cn } from '../../lib/cn';
import { UserMenu } from '../UserMenu/UserMenu';
import type { SidebarUser } from '../Sidebar/Sidebar';

export interface CalendarShellHeaderProps {
  /** TODAY · workspace — top-left, aligned with actions row. */
  eyebrow: React.ReactNode;
  /** Date title + stats — second row, left. */
  left: React.ReactNode;
  /** Live / Options / AI — top-right. */
  actions: React.ReactNode;
  /** ◀ ▶ Today Day/Week/Month — second row, right (optional). */
  nav?: React.ReactNode;
  /** The account menu, pinned far-right of the top row (spec 41). */
  user?: SidebarUser;
  className?: string;
}

export function CalendarShellHeader({ eyebrow, left, actions, nav, user, className }: CalendarShellHeaderProps) {
  return (
    <div
      className={cn(
        'cal-fade sticky top-0 z-[var(--z-sticky)] shrink-0',
        'bg-[var(--surface-app)] px-[30px] pb-0 pt-6',
        className,
      )}
    >
      <div className="mb-3 flex items-center justify-between gap-7">
        <div className="min-w-0 flex-1">{eyebrow}</div>
        <div className="flex shrink-0 items-center gap-2">
          {actions}
          {user ? (
            <>
              <span className="mx-0.5 h-6 w-px bg-[var(--cream-2)]" aria-hidden />
              <UserMenu user={user} />
            </>
          ) : null}
        </div>
      </div>
      <div className={cn('flex gap-7 pb-[26px]', nav ? 'items-end justify-between' : 'items-end')}>
        <div className="min-w-0 flex-1">{left}</div>
        {nav ? <div className="flex shrink-0 items-center">{nav}</div> : null}
      </div>
    </div>
  );
}
